import { render, staticRenderFns } from "./CreatorDetailMarket.vue?vue&type=template&id=0d2d5c94&scoped=true"
import script from "./CreatorDetailMarket.vue?vue&type=script&lang=js"
export * from "./CreatorDetailMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d5c94",
  null
  
)

export default component.exports